export default __webpack_public_path__ + "static/media/portfolio-203.45fbf2bb.jpg";